import { clientRunDurationLabel } from './clientRunDurationLabel'
import { runDurationLabel, timelineDurationLabel } from './timelineDuration'

export function timelineFinishedDuration({
  hasPublicTimeline,
  publicActivity,
  publicView,
  view,
  clientRunStartedAt,
  clientRunCompletedAt,
}) {
  const fromClient = clientRunDurationLabel(clientRunStartedAt, clientRunCompletedAt)
  if (fromClient) return fromClient
  if (hasPublicTimeline) {
    return (
      runDurationLabel(publicActivity.startedAt, publicActivity.completedAt) ??
      timelineDurationLabel(publicView.phases.flatMap((phase) => phase.rows))
    )
  }
  return timelineDurationLabel(view.rows)
}
